import { Injectable } from '@angular/core';

export class Project {
  id: Number;
  title: String;
  description: String;
  date_start: String;
  date_end: String;
  owner: String;
  color: String;
}



export class Task {

  id: Number;
  project_id: Number;
  title: String;
  description: String;
  date_start: String;
  date_end: String;
  owner: String;
  assigned: String [];
}

const PROJECTS: Project[] = [
  { id: 1, title: 'Project 1', description: '', date_start: '', date_end: '', owner:'Ollie', color: 'pink' },
  { id: 2, title: 'My Project', description: '', date_start: '', date_end: '', owner:'Ollie', color: 'blue'  },
  { id: 3, title: 'New Project', description: '', date_start: '', date_end: '', owner:'Ollie', color: 'orange'  },
  { id: 4, title: 'Website', description: '', date_start: '', date_end: '', owner:'Ollie', color: 'yellow'  },
  { id: 5, title: 'New Website', description: '', date_start: '', date_end: '', owner:'Ollie', color: 'red'  }
];

const TASKS: Task[] = [
  { id: 1, project_id: 1, title: 'Task 1', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris'] },
  { id: 2, project_id: 1, title: 'Task 2', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris']},
  { id: 3, project_id: 1,title: 'New Task', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris']},
  { id: 4, project_id: 1,title: 'Website', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris']},
  { id: 5, project_id: 1,title: 'New Website', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris']}
];



@Injectable()
export class ProjectService {

  getProjects():Promise<Project[]> {
    return Promise.resolve(PROJECTS);
  }

  getProjectsSlowly():Promise<Project[]> {
  return new Promise(resolve => {
    // Simulate server latency with 2 second delay
    setTimeout(() => resolve(this.getProjects()), 3000);
    });
  }

  getProject(id: number): Promise<Project> {
  return this.getProjects()
             .then(Project => PROJECTS.find(Project => Project.id === id));
  }


  getTasks():Promise<Task[]> {
    return Promise.resolve(TASKS);
  }
}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/services/project.service.ts